import { apiFetch } from "@core/http";
import type { components } from "@core/types/openapi";

export type RedemptionReceipt = components["schemas"]["RedemptionReceipt"];

// SPEC-304 §2 (`POST /v1/validator/redemptions`): confirma el consumo en una
// sola transacción y devuelve el comprobante. `idempotencyKey` la genera
// `ConfirmScreen.handleConfirm` (R-01, `crypto.randomUUID()`) y esta pantalla
// la reutiliza tal cual, inclusive al reintentar tras un corte de conexión
// (RF-VAL-34) — regenerarla en cada intento rompería la garantía de que un
// reintento con la misma clave devuelve el resultado original en vez de
// cobrar dos veces (ADR-004).
export function confirmRedemption(
  publicCode: string,
  idempotencyKey: string,
  bearerToken: string,
): Promise<RedemptionReceipt> {
  return apiFetch<RedemptionReceipt>("/v1/validator/redemptions", {
    method: "POST",
    body: { publicCode },
    idempotencyKey,
    bearerToken,
  });
}
